export enum GraphDotColor {
  Default = "Default",
  ReadingBased = "Reading-based",
  White = "White",
}
